import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client.
 *
 * Defaults chosen for Ando v2:
 * - `staleTime: 60s` — domain data is mostly stable per session; we let
 *   server-driven invalidations (WS events) drive freshness, not aggressive
 *   refetching.
 * - `gcTime: 5min` — keep query caches warm while the user navigates between
 *   workspace tabs, but free memory if a tab is unmounted for a while.
 * - `retry: 2` with capped exponential backoff — survives transient blips
 *   without amplifying outages.
 * - `refetchOnWindowFocus: false` — Ando is desktop-ish (Tauri target) and the
 *   WS channel already pushes fresh state.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = createQueryClient();
